import { FC } from 'react';

export interface ImageDocumentPaneProps {
  downloadURL: string;
  fileName: string;
  onError: () => void;
}

export const ImageDocumentPane: FC<ImageDocumentPaneProps> = ({ downloadURL, fileName, onError }) => (
  <img src={downloadURL} alt={fileName} className="max-h-full max-w-full object-contain" onError={onError} />
);
